<template>
    <div class="mainPage">
        <div class="topBox"><i class="el-icon-back mr10 f20" @click="goBack"></i>批量制券</div>
           <div class="mainBox">
            <el-row>
                 <el-button type="primary" class="ml10" @click="toCreateCoupon">批量制券</el-button>
            </el-row>
                <el-row class="mt30">
                    <el-form >
                        <el-col :span="5">
                            <el-form-item label="制券批次号:" label-width="90px">
                                   <el-input v-model="searchForm.batchNumber" placeholder="请输入制券批次号"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="9">
                            <el-form-item label="制券时间:" label-width="80px">
                                <el-date-picker
                                    v-model="searchForm.opearteTime"
                                    type="datetimerange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        
                      <el-button type="primary" class="ml10" @click="search"
                        ><i class="el-icon-search el-icon--left fw600"></i>查询</el-button
                        >
                        <el-button type="" @click="reSet"
                        ><i
                            v-if="!isLoading"
                            class="el-icon-refresh-right el-icon--left fw600"
                        ></i
                        ><i v-if="isLoading" class="el-icon-loading el-icon--left fw600"></i
                        >重置</el-button
                        >
                    </el-form>
                </el-row>
                <el-row>
                 <el-table ref="multipleTable" border :data="tableData" tooltip-effect="dark" style="width: 100%" >
                    <el-table-column prop="batchNumber" label="批次号" align="center"  > </el-table-column>
                    <el-table-column prop="operateNum" label="制券张数" align="center" > </el-table-column>
                    <el-table-column prop="createShop" label="制券门店" align="center" show-overflow-tooltip="" > </el-table-column>
                    <el-table-column prop="creater" label="制券人" align="center" > </el-table-column>
                    <el-table-column prop="createTime" label="制券时间" align="center" > </el-table-column>
                    <el-table-column prop="sendCouponeShop" label="指定发券门店" align="center" show-overflow-tooltip=""> </el-table-column>
                    <el-table-column prop="createStatus" label="批量制券状态" align="center" > 
                        <template slot-scope="scope">
                            <div v-if="scope.row.createStatus == '1'" class="successBox">
                                <i class="el-icon-success successIcon"></i>
                                <span>已完成</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="" label="操作" align="center" > 
                        <template slot-scope="scope">
                              <div class="toolBtn" @click="toBanchDetail(scope.row)">批次券详情</div>
                        </template>
                    </el-table-column>
                  </el-table>
                      <div class="footerBox">
                        <!-- 分页区域 -->
                        <el-pagination
                          @size-change="handleSizeChange"
                          @current-change="handleCurrentChange"
                          :current-page.sync="queryInfo.currPage"
                          :page-sizes="[10, 20, 30, 50]"
                          :page-size="queryInfo.pageSize"
                          layout="total, sizes, prev, pager, next, jumper"
                          :total="total"
                        ></el-pagination>
                      </div>
              </el-row>
           </div>
    </div>
</template>

<script>
export default {
    data(){
        return {
            total:2,
            tableData:[
                {
                   batchNumber:'12720632',
                   operateNum:'10',
                   createShop:'满品客大饭堂（习友路店）',
                   creater:'测试(00002)',
                   createTime:'2023-08-01 11:41:36',
                   sendCouponeShop:'满品客大饭堂（习友路店）',
                   createStatus:'1',
                },
                {
                   batchNumber:'12253541',
                   operateNum:'100',
                   createShop:'满品客大饭堂（习友路店）',
                   creater:'杨总(00001)',
                   createTime:'2023-06-15 20:05:36',
                   sendCouponeShop:'满品客大饭堂（习友路店）',
                   createStatus:'1',
                },
            ],
          isLoading:false,
          queryInfo:{
             pageSize: 10,
             currPage: 1,
             condition:{
               
             }
          },
          searchForm:{
            batchNumber:'',
            opearteTime:[],
          },
          operaterList:[
            {
              label:'测试',
              value:'00002',
            },
            {
              label:'杨总',
              value:'00001',
            },
          ],
        }
    },
    methods:{
      //前往制券
      toCreateCoupon(){
           this.$router.push({path:'/createCoupon'})
      },
      //查看批次券详情
      toBanchDetail(row){
          this.$router.push({path:'/couponUseDetail',query:{batchNumber:row.batchNumber,page:'banchCreate'}})
      },
        //搜索
        search(){

        },
        //重置
        reSet(){
           this.searchForm = {
            batchNumber:'',
            opearteTime:[],
          }
        },
       //返回
        goBack (){
            this.$router.push({path:'/couponManage'})
        },
        // 监听 pagesize改变的事件
        handleSizeChange(newSize) {
        this.queryInfo.pageSize = newSize;
        //   this.getListData();
        },
        // 监听 页码值 改变事件
        handleCurrentChange(newSize) {
        this.queryInfo.currPage = newSize;
        //   this.getListData();
        },
    }
}
</script>

<style lang="less" scoped>
.mainPage {
  width: 99%;
  height: 90vh;
  /* padding: 30px; */
  background: #fff;
  overflow-y: scroll;
}
.topBox{
    /* width: 100%; */
    display: flex;
    align-items: center;
    padding: 20px;
    border-bottom: 1px solid #ddd;
    font-size: 18px;
}
.f20{
    font-size: 20px;
    cursor: pointer;
}
/deep/ .el-select .el-input.is-focus .el-input__inner {
  border: 1px solid #f59a23 !important;
}
/deep/  .el-select-dropdown__item.selected span{
     color:#222 !important;
}
.mainBox{
    /* width: 100%; */
    // height: 70vh;
    // background:#fff;
    padding: 30px;
    // overflow-y: scroll;
}
/deep/ .el-date-editor--datetimerange.el-input, .el-date-editor--datetimerange.el-input__inner{
    width: 100%;
}
/deep/ .el-button--primary {
  background-color: rgb(245, 154, 35);
  border-color: rgb(245, 154, 35);
}
/deep/ .el-button:focus,
.el-button:hover {
  color: rgb(245, 154, 35);
  border-color: #f5dab1;
  background-color: #fdf6ec;
}
/deep/ .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
      color: #C0C4CC;
    cursor: not-allowed;
    background-image: none;
    background-color: #FFF;
    border-color: #EBEEF5;
}
 /deep/ .el-table th>.cell{
    font-size: 15px;
    color: #222;
    font-weight: 500;
    padding: 8px 0;
 }
  /deep/ .el-table th, /deep/ .el-table tr{
    font-size: 14px;
    color: #222;
 }
  .toolBtn{
    color: #f59a23;
    font-size: 14px;
    cursor: pointer;
 }
 .successBox{
    display: flex;
    align-items: center;
    color: #53c21d;
    justify-content: center;
 }
 .successIcon{
    color: #53c21d;
    font-size: 16px;
    margin-right: 12px;
 }
 .footerBox{
  text-align: right;
 }
 /deep/ .el-pager li.active{
  color: #f59a23;
 }
 /deep/ .el-select-dropdown__item.selected{
   color: #f59a23;
 }
</style>